<template>
	<div>
		<p class="details_header">
			<span @click="goback()">
				<i class="icon wjpc-iconfont wjpc-icon-arrow-left-bold"></i>
				<!-- 样本编号:{{ this.$route.query.id }} -->
				返回
			</span>
		</p>

		<div class="interviewerBox">
			<div class="topTableBtn">
				<el-button type="primary" @click="addInterview">添加</el-button>
				<el-button type="danger" @click="deleteInterview">删除</el-button>
			</div>
			<div class="topTable">
				<el-table border :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55" align="center"></el-table-column>
					<el-table-column align="center" fixed prop="isState" label="访问状态"></el-table-column>
					<el-table-column align="center" prop="isDesc" label="状态描述"></el-table-column>
					<el-table-column align="center" prop="ssId" label="样本状态">
						<template slot-scope="scope">
							<span v-if="scope.row.ssId == 1">初始</span>
							<span v-else-if="scope.row.ssId == 2">读取</span>
							<span v-else-if="scope.row.ssId == 3">中断</span>
							<span v-else-if="scope.row.ssId == 4">甄别</span>
							<span v-else-if="scope.row.ssId == 5">条件不符</span>
							<span v-else-if="scope.row.ssId == 6">完成</span>
							<span v-else-if="scope.row.ssId == 7">配额已满</span>
							<span v-else-if="scope.row.ssId == 8">无效样本</span>
							<span v-else-if="scope.row.ssId == 9">预拨取号</span>
							<span v-else-if="scope.row.ssId == 10">审核作废</span>
							<span v-else-if="scope.row.ssId == 11">稍后</span>
							<span v-else-if="scope.row.ssId == 12">约访</span>
							<span v-else-if="scope.row.ssId == 0">无</span>
							<span v-else>其他</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="isPromissoryInterview" label="是否系统">
						<template slot-scope="scope">
							<span v-if="scope.row.isPromissoryInterview == 1">系统字段</span>
							<span v-else>非系统字段</span>
						</template>
					</el-table-column>
					<el-table-column align="center" fixed="right" label="操作" width="120">
						<template slot-scope="scope">
							<el-button :disabled="scope.row.isPromissoryInterview == 1" @click.native.prevent="editRow(scope)" type="text" size="small">修改</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="pagination.pageNo"
						:page-sizes="[10, 50, 100, 200, 300, 400]"
						:page-size="pagination.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="pagination.total"
					></el-pagination>
				</div>
			</div>
		</div>

		<!-- 添加编辑 -->
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="800" center :close-on-click-modal="false">
			<span>
				<el-form :model="form">
					<el-form-item label="访问状态" :label-width="formLabelWidth"><el-input v-model="form.isState" autocomplete="off"></el-input></el-form-item>
					<el-form-item label="样本状态" :label-width="formLabelWidth">
						<el-radio v-model="form.ssId" label="0">无</el-radio>
						<el-radio v-model="form.ssId" label="1">放回</el-radio>
						<el-radio v-model="form.ssId" label="8">无效</el-radio>
						<el-radio v-model="form.ssId" label="11">稍后</el-radio>
					</el-form-item>
					<el-form-item label="样本描述" :label-width="formLabelWidth">
						<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.isDesc"></el-input>
					</el-form-item>
				</el-form>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" type="primary" @click="addInterviewstate">确 定</el-button>
				<el-button size="medium" @click="centerDialogVisible = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			selectionList: [],
			title: '添加',
			addEditType: 1,
			form: {
				isState: '',
				ssId: '',
				isDesc: ''
			},
			formLabelWidth: '120px',
			centerDialogVisible: false,
			id: '',
			pagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			},
			tableData: []
		};
	},
	created() {
		this.id = this.$route.query.id;
		this.loadData();
	},
	methods: {
		deleteInterview() {
			this.$confirm('此操作将永久删除状态, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.removeInterviewstate}`,
						method: 'POST',
						data: {
							id: that.selectionList.toString()
						},
						cb(res) {
							if (res.code == 0) {
								that.loadData();
								that.$message.success('删除成功。');
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		// 添加
		addInterview() {
			this.title = '添加';
			this.addEditType = 1;
			this.form = {};
			this.centerDialogVisible = true;
		},
		// 编辑
		editRow(scope) {
			this.addEditType = 2;
			this.title = '编辑';
			this.form = JSON.parse(JSON.stringify(scope.row));
			delete this.form.isPromissoryInterview;
			delete this.form.createId;
			delete this.form.createTime;
			this.centerDialogVisible = true;
		},
		addInterviewstate() {
			if (this.form.isState == '') {
				this.$message({
					message: '请填写访问状态.',
					type: 'warning'
				});
				return false;
			}
			let that = this;
			let data = that.form;
			let url = '';
			if (that.addEditType == 1) {
				url = `${that.$config.service.addInterviewstate}`;
			} else {
				url = `${that.$config.service.modifyInterviewstate}`;
			}
			let params = {
				that: this,
				url: url,
				method: 'POST',
				data: data,
				cb(res) {
					console.log('查询全部全部字段对照', res);
					if (res.code == 0) {
						that.centerDialogVisible = false;
						that.form = {
							isState: '',
							ssId: '',
							isDesc: ''
						};
						that.loadData();
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		loadData() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryInterviewstate}?pageNo=${this.pagination.pageNo}&pageSize=${this.pagination.pageSize}`,
				method: 'GET',
				data: {},
				cb(res) {
					console.log('查询全部全部字段对照', res);
					if (res.code == 0) {
						that.tableData = res.resultBody.records;
						that.pagination.total = res.resultBody.total;
					} else {
						that.tableData = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleSelectionChange(val) {
			console.log(val);
			let tempArray = [];
			val.forEach(item => {
				tempArray.push(item.id);
			});
			this.selectionList = tempArray;
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pagination.pageSize = val;
			this.loadData();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.pagination.pageNo = val;
			this.loadData();
		},
		goback() {
			setTimeout(() => {
				this.$router.replace({ path: '/onHook', query: { id: this.id } });
			}, 0);
		}
	}
};
</script>

<style lang="scss" scoped>
.details_header {
	// max-width: 1200px;
	height: 60px;
	line-height: 60px;
	text-align: center;
	background-color: #0080ff;
	margin: auto;
	display: flex;
	justify-content: space-between;
	span {
		// color: #333333;
		color: #fff;
		font-size: 16px;
		padding: 0px 30px;
	}
	margin-bottom: 20px;
	cursor: pointer;
}
.interviewerBox {
	width: 1200px;
	margin: 0px auto;
	.topTableBtn {
		display: flex;
		justify-content: space-between;
	}
	.topTable {
		margin-top: 20px;
		margin-bottom: 20px;
		/deep/.is-leaf {
			background-color: #007edc;
			color: #ffffff;
			font-size: 16px;
		}
		.radioBtn {
			text-align: right;
			margin-top: 20px;
		}
		.block {
			text-align: right;
			margin-top: 20px;
		}
	}
}
</style>
